import React from 'react';
import T from 'prop-types';

import { Container } from './style';

const Layout = ({ children }) => <Container>{children}</Container>;

Layout.defaultProps = {
  children: null,
};

Layout.propTypes = {
  children: T.node,
};

export default Layout;
